const CANHCAM_APP = {"ACTIVE_FIXED_HEADER": true,"HEADER_TRANPARENT": false,"ACTIVE_HEADER_POSITION": 1,"ACTIVE_PADDING_MAIN": true,"ACTIVE_VALIDATOR": true,"ACTIVE_SELECT": true,"ACTIVE_FIXED_FOOTER": true,"ACTIVE_LIST_TO_SELECT": true,"DISPLAY_FOOTER": 600,"ACTIVE_RESPONSIVE": true,"ACTIVE_BACKTOTOP": true,"DISPLAY_BACKTOTOP": 100,"CHANGE_GRID": 991,"CHANGE_GRID_SM": 767,"DEV_MODE": false,"DEV_MODE_GIRD_FULL": false}
function backToTop() {
    if ($('#back-to-top').length) {
        var backToTop = function() {
            var scrollTop = $(window).scrollTop();
            if (scrollTop > CANHCAM_APP.DISPLAY_BACKTOTOP) {
                $('#back-to-top').addClass('show');
            } else {
                $('#back-to-top').removeClass('show');
            }
        };
        backToTop();
        $(window).on('scroll', function() {
            backToTop();
        });
        $('#back-to-top').on('click', function(e) {
            e.preventDefault();
            $('html,body').animate({
                scrollTop: 0
            }, 700);
        });
    }
}

$(document).ready(function() {
    if (CANHCAM_APP.ACTIVE_BACKTOTOP) {
        backToTop()
    }
});
function CanhCamResponsive() {
	// Set BG Mask
	$('[bg-mask]').each(function () {
		var bgimg = $(this).attr('bg-mask');
		$(this).css({
			"mask-image": "url(" + bgimg + ")",
			"mask-position": "center center",
			"mask-repeat": "no-repeat",
			"-webkit-mask-image": "url(" + bgimg + ")",
			"-webkit-mask-position": "center center",
			"-webkit-mask-repeat": "no-repeat"
		});
	})
	// Set BG Resposive
	$('[bg-img]').each(function () {
		var bgimg = $(this).attr('bg-img');
		var pos = $(this).attr('bg-pos');
		var size = $(this).attr('bg-size');
		if (pos && pos.length > 0) {
			$(this).css({
				"background-position": pos
			});
		} else {
			$(this).css({
				"background-position": "center center"
			});
		}
		if (size && size.length > 0) {
			$(this).css({
				"background-size": size
			});
		} else {
			$(this).css({
				"background-size": "cover"
			});
		}
		$(this).css({
			"background-image": "url(" + bgimg + ")"
		});
	});

	$('[bg-img-responsive]').each(function () {
		var bgimg = $(this).attr('bg-img-responsive');
		var bgimgsm = $(this).attr('bg-img-responsive-sm');
		var bgimgxs = $(this).attr('bg-img-responsive-xs');
		if ($(window).width() >= CANHCAM_APP.CHANGE_GRID) {
			$(this).css({
				"background-image": "url(" + bgimg + ")",
				"background-position": "center center",
				"background-size": "cover"
			});
		} else if ($(window).width() < CANHCAM_APP.CHANGE_GRID && $(window).width() > CANHCAM_APP.CHANGE_GRID_SM) {
			$(this).css({
				"background-image": "url(" + bgimgsm + ")",
				"background-position": "center center",
				"background-size": "cover"
			});
		} else {
			$(this).css({
				"background-image": "url(" + bgimgxs + ")",
				"background-position": "center center",
				"background-size": "cover"
			});
		}
	});

	$('[img-src-responsive]').each(function () {
		var bgimg2 = $(this).attr('img-src-responsive');
		var bgimg2sm = $(this).attr('img-src-responsive-sm');
		var bgimg2xs = $(this).attr('img-src-responsive-xs');
		if ($(window).width() >= CANHCAM_APP.CHANGE_GRID) {
			$(this).attr("src", "" + bgimg2 + "");
		} else if ($(window).width() < CANHCAM_APP.CHANGE_GRID && $(window).width() > CANHCAM_APP.CHANGE_GRID_SM) {
			$(this).attr("src", "" + bgimg2sm + "");
		} else {
			$(this).attr("src", "" + bgimg2xs + "");
		}
	});

};

$(function () {
	if (CANHCAM_APP.ACTIVE_RESPONSIVE) {
		CanhCamResponsive();
	}
})

$(window).resize(function () {
	if (CANHCAM_APP.ACTIVE_RESPONSIVE) {
		CanhCamResponsive();
	}
})


// Thêm [dropdown-type="hover"] vào thẻ a để bật tính năng hover open dropdown 
// if ($(window).width() > CANHCAM_APP.CHANGE_GRID) {
// 	$('.dropdown').on('mouseenter mouseleave', function () {
// 		var ___d = $(this).find('[dropdown-type="hover"]').parents('.dropdown')
// 		if (___d && ___d.length > 0) {
// 			$(this).find('[dropdown-type="hover"]').removeAttr('data-toggle')
// 			setTimeout(function () {
// 				___d[___d.is(':hover') ? 'addClass' : 'removeClass']('show');
// 				___d.is(':hover') ? ___d.find('.dropdown-menu').show() : ___d.find('.dropdown-menu').hide()
// 			}, 10);
// 		}
// 	})
// } else {
// 	$('.dropdown').each(function () {
// 		$(this).addClass('show')
// 		$(this).find('.dropdown-menu').show()
// 	})
// }



$('[data-count-id]').each(function() {
	console.log($(this)[0].dataset.countId)
	window[$(this)[0].dataset.countId] = false
})

function countUpCanhCam() {

	$('[data-count]').each(function () {
		let elm = $(this).offset().top
		let docH = $(window).height()
		let docS = $(window).scrollTop()
		let padingTop = 0
		if ($(this).attr('data-top') && $(this).attr('data-top').length) {
			padingTop = parseInt($(this).attr('data-top'));
		}
		let result = (elm + padingTop) - (docH + docS)
		let countId = $(this)[0].dataset.countId
		let run = window[countId]

		if (result <= 0 && !run) {
			let $this = $(this),
				countTo = $this.attr('data-count'),
				durationTo = parseInt($this.attr('data-duration')),
				textAfterCount = $this.attr('data-text-after-count')
			$({ countNum: $this.text() }).animate({
				countNum: countTo
			}, {
					duration: durationTo,
					easing: 'linear',
					step: function () {
						$this.text(Math.floor(this.countNum));
					},
					complete: function () {
						$this.text(this.countNum);
						if (textAfterCount) {
							$this.text(textAfterCount)
						}
						window[countId] = true
					}
				});
		}
	});
}

$(document).ready(function () {
	countUpCanhCam()

});

$(window).scroll(function () {
	countUpCanhCam()

});

$(window).resize(function () {
	countUpCanhCam()
})

// function setFooter() {
// 	var bodyHeight = $("body").outerHeight(),
// 		headerHeight = $("header").outerHeight(),
// 		footerHeight = $("footer").outerHeight(),
// 		mainHeight = $("main").outerHeight(),
// 		curentHeight = mainHeight + headerHeight + footerHeight,
// 		curentfixedHeight = mainHeight + footerHeight,
// 		newHeight = bodyHeight - (headerHeight + footerHeight),
// 		newfixedHeight = bodyHeight - footerHeight;
// 	if ($(window).width() > CANHCAM_APP.DISPLAY_FOOTER) {
// 		if ($(window).width() <= CANHCAM_APP.CHANGE_GRID) {
// 			$("main").css('min-height', newfixedHeight + 'px')
// 		} else {
// 			if (!CANHCAM_APP.ACTIVE_FIXED_HEADER) {
// 				$("main").css('min-height', newHeight + 'px')
// 			} else {
// 				$("main").css('min-height', newfixedHeight + 'px')
// 			}
// 		}
// 	} else {
// 		$("main").css('min-height', 'initial')
// 	}
// }

// $(document).ready(function () {
// 	if (CANHCAM_APP.ACTIVE_FIXED_FOOTER) {
// 		setFooter()
// 	}
// });

// $(window).resize(function () {
// 	if (CANHCAM_APP.ACTIVE_FIXED_FOOTER) {
// 		setFooter()
// 	}
// })



/*!
 * sticky-footer v4.2.0: Responsive sticky footers
 * (c) 2016 Chris Ferdinandi
 * MIT License
 * http://github.com/cferdinandi/sticky-footer
 */

// (function (root, factory) {
// 	if ( typeof define === 'function' && define.amd ) {
// 		define([], factory(root));
// 	} else if ( typeof exports === 'object' ) {
// 		module.exports = factory(root);
// 	} else {
// 		root.stickyFooter = factory(root);
// 	}
// })(typeof global !== 'undefined' ? global : this.window || this.global, (function (root) {

// 	'use strict';

// 	//
// 	// Variables
// 	//

// 	var stickyFooter = {}; // Object for public APIs
// 	var supports = 'querySelector' in document && 'addEventListener' in root; // Feature test
// 	var settings, wrap, footer, eventTimeout;

// 	// Default settings
// 	var defaults = {
// 		selectorWrap: '[data-sticky-wrap]',
// 		selectorFooter: '[data-sticky-footer]',
// 		callback: function () {}
// 	};


// 	//
// 	// Methods
// 	//

// 	/**
// 	 * Merge two or more objects. Returns a new object.
// 	 * @private
// 	 * @param {Boolean}  deep     If true, do a deep (or recursive) merge [optional]
// 	 * @param {Object}   objects  The objects to merge together
// 	 * @returns {Object}          Merged values of defaults and options
// 	 */
// 	var extend = function () {

// 		// Variables
// 		var extended = {};
// 		var deep = false;
// 		var i = 0;
// 		var length = arguments.length;

// 		// Check if a deep merge
// 		if ( Object.prototype.toString.call( arguments[0] ) === '[object Boolean]' ) {
// 			deep = arguments[0];
// 			i++;
// 		}

// 		// Merge the object into the extended object
// 		var merge = function (obj) {
// 			for ( var prop in obj ) {
// 				if ( Object.prototype.hasOwnProperty.call( obj, prop ) ) {
// 					// If deep merge and property is an object, merge properties
// 					if ( deep && Object.prototype.toString.call(obj[prop]) === '[object Object]' ) {
// 						extended[prop] = extend( true, extended[prop], obj[prop] );
// 					} else {
// 						extended[prop] = obj[prop];
// 					}
// 				}
// 			}
// 		};

// 		// Loop through each object and conduct a merge
// 		for ( ; i < length; i++ ) {
// 			var obj = arguments[i];
// 			merge(obj);
// 		}

// 		return extended;

// 	};

// 	/**
// 	 * Get height of the viewport
// 	 * @private
// 	 * @return {Number} Height of the viewport in pixels
// 	 */
// 	var getViewportHeight = function () {
// 		return Math.max( document.documentElement.clientHeight, window.innerHeight || 0 );
// 	};

// 	/**
// 	 * Set page wrapper height to fill viewport (minus footer height)
// 	 * @private
// 	 * @param {Element} wrap Page wrapper
// 	 * @param {Element} footer Page footer
// 	 * @param {Object} settings
// 	 */
// 	var setWrapHeight = function ( wrap, footer, settings ) {
// 		wrap.style.minHeight = ( getViewportHeight() - footer.offsetHeight ) + 'px';
// 		settings.callback(); // Run callback
// 	};

// 	/**
// 	 * Destroy the current initialization.
// 	 * @public
// 	 */
// 	stickyFooter.destroy = function () {

// 		if ( !settings ) return;

// 		// Unset styles
// 		document.documentElement.style.minHeight = '';
// 		document.body.style.minHeight = '';
// 		wrap.style.minHeight = '';
// 		window.removeEventListener( 'resize', eventThrottler, false );

// 		// Reset variables
// 		settings = null;
// 		wrap = null;
// 		footer = null;
// 		eventTimeout = null;

// 	};

// 	/**
// 	 * On window scroll and resize, only run events at a rate of 15fps for better performance
// 	 * @private
// 	 * @param  {Function} eventTimeout Timeout function
// 	 * @param  {NodeList} wrap The content wrapper for the page
// 	 * @param  {NodeList} footer The footer for the page
// 	 * @param  {Object} settings
// 	 */
// 	var eventThrottler = function () {
// 		if ( !eventTimeout ) {
// 			eventTimeout = setTimeout((function() {
// 				eventTimeout = null;
// 				setWrapHeight( wrap, footer, settings );
// 			}), 66);
// 		}
// 	};

// 	/**
// 	 * Initialize Plugin
// 	 * @public
// 	 * @param {Object} options User settings
// 	 */
// 	stickyFooter.init = function ( options ) {

// 		// feature test
// 		if ( !supports ) return;

// 		// Destroy any existing initializations
// 		stickyFooter.destroy();

// 		// Selectors and variables
// 		settings = extend( defaults, options || {} ); // Merge user options with defaults
// 		wrap = document.querySelector( settings.selectorWrap );
// 		footer = document.querySelector( settings.selectorFooter );

// 		// Sanity check
// 		if ( !wrap || !footer ) return;

// 		// Stick footer
// 		document.documentElement.style.minHeight = '100%';
// 		document.body.style.minHeight = '100%';
// 		setWrapHeight( wrap, footer, settings );
// 		window.addEventListener( 'resize', eventThrottler, false); // Run Sticky Footer on window resize

// 	};


// 	//
// 	// Public APIs
// 	//

// 	return stickyFooter;

// }));

function setHeader(elm) {
	if (elm >= CANHCAM_APP.ACTIVE_HEADER_POSITION) {
		$("header").addClass('active');
	} else {
		$("header").removeClass('active');
	}
}

$(document).ready(function () {
	if (CANHCAM_APP.ACTIVE_FIXED_HEADER) {
		$("header").addClass('fixedheader');
		if ($(window).scrollTop() >= CANHCAM_APP.ACTIVE_HEADER_POSITION) {
			setHeader($(window).scrollTop());
		}
	} else {
		if ($(window).width() <= CANHCAM_APP.CHANGE_GRID) {
			$("header").addClass('fixedheader');
		} else {
			$("header").removeClass('fixedheader');
		}
	}
	if ($("header").hasClass("fixedheader")) {
		$("main").addClass('main-fixedheader');
	}
});

// Fixed Header
$(window).scroll(function () {
	setHeader($(document).scrollTop());
});
// Fixed Header
$(window).resize(function () {
	if (!CANHCAM_APP.ACTIVE_FIXED_HEADER) {
		if ($(window).width() <= CANHCAM_APP.CHANGE_GRID) {
			$("header").addClass('fixedheader');
		} else {
			$("header").removeClass('fixedheader');
		}
	}
});


function setMain() {
    var
		headerHeight = $("header").outerHeight();
		if ($(window).width() <= CANHCAM_APP.CHANGE_GRID) {
				$("main").css('padding-top', headerHeight + 'px')
		} else {
			if (!CANHCAM_APP.ACTIVE_PADDING_MAIN) {
				$("main").css('padding-top', '0px')
			} else {
				if (!CANHCAM_APP.ACTIVE_FIXED_HEADER) {
					$("main").css('padding-top', 'initial')
				} else {
					$("main").css('padding-top', headerHeight + 'px')
				}
			}
		}
}

$(document).ready(function() {
    setMain()
});

$(window).resize(function() {
    setMain()
})

function setHeaderTranparent(elm) {
	if (elm >= CANHCAM_APP.ACTIVE_HEADER_POSITION) {
		$("header").removeClass('has-tranparent');
	} else {
		$("header").addClass('has-tranparent');
	}
}

$(document).ready(function () {
	if (CANHCAM_APP.HEADER_TRANPARENT) {
		$("header").addClass('has-tranparent');
		if ($(window).scrollTop() >= CANHCAM_APP.ACTIVE_HEADER_POSITION) {
			setHeaderTranparent($(window).scrollTop());
		}
	}

});

// Tranparent Header
$(window).scroll(function () {
	if (CANHCAM_APP.HEADER_TRANPARENT) {
		setHeaderTranparent($(document).scrollTop());
	}
});


function canhcamID(e) {
	var text = "";
	var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
	for (var i = 0; i < e; i++)
		text += possible.charAt(Math.floor(Math.random() * possible.length));
	return text;
}

function b64EncodeUnicode(str) {
	return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
		function toSolidBytes(match, p1) {
			return String.fromCharCode('0x' + p1);
		}));
}

function b64DecodeUnicode(str) {
	return decodeURIComponent(atob(str).split('').map(function (c) {
		return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
	}).join(''));
}

// Copyright 2014-2017 The Bootstrap Authors
// Copyright 2014-2017 Twitter, Inc.
if (navigator.userAgent.match(/IEMobile\/10\.0/)) {
    var msViewportStyle = document.createElement('style')
    msViewportStyle.appendChild(
        document.createTextNode(
            '@-ms-viewport{width:auto!important}'
        )
    )
    document.head.appendChild(msViewportStyle)
}

$(function() {
    var nua = navigator.userAgent
    var isAndroid = (nua.indexOf('Mozilla/5.0') > -1 && nua.indexOf('Android ') > -1 && nua.indexOf('AppleWebKit') > -1 && nua.indexOf('Chrome') === -1)
    if (isAndroid) {
        $('select.form-control').removeClass('form-control').css('width', '100%')
    }
})

console.log('%cCANHCAM', 'font-size:100px;color:#ff451a;text-shadow:0 1px 0 #f73936,0 2px 0 #f73936 ,0 3px 0 #f73936 ,0 4px 0 #f73936 ,0 5px 0 #f73936 ,0 6px 1px rgba(0,0,0,.1),0 0 5px rgba(0,0,0,.1),0 1px 3px rgba(0,0,0,.3),0 3px 5px rgba(0,0,0,.2),0 5px 10px rgba(0,0,0,.25),0 10px 10px rgba(0,0,0,.2),0 20px 20px rgba(0,0,0,.15);')
console.log('%c CANHCAM ' + '%c - The best Web Solutions Provider', 'border-radius: 2px; padding: 3px; background: #ff451a; color: #FFF', 'color: #ff451a');
console.warn("CANHCAM warning: This is a browser feature intended for developers. If someone told you to copy and paste something here to enable a CANHCAM feature or 'hack' someone's account, it is a scam and will give them access to your CANHCAM account.");
document.onkeyup = function (a) { if ((a = a || window.event).altKey && a.ctrlKey && a.shiftKey && 13 == a.which) return $("body"), alert(b64DecodeUnicode("QkFPIE5HVVlFTiAtIDA5Njk2ODk4OTMKRW1haWw6IGJhb25ndXllbnlhbUBnbWFpbC5jb20KV2ViOiBiYW9uZ3V5ZW55YW0uZ2l0aHViLmlv")), !1 };


// $(document).ready(function () {
// 	if (CANHCAM_APP.ACTIVE_SELECT) {
// 		$(".select2").select2({
// 			placeholder: "Chọn một"
// 		});

// 		$('.select2').on("select2:select", function (e) {
// 			var valSelect = $(e.currentTarget).val()
// 		});
// 		$('.select2').on("select2:unselect", function (e) {
// 			var valUnselect = $(e.currentTarget).val()
// 		});
// 	}
// });

// function selectResset(e) {
// 	$(e).val(null).trigger("change", 0);
// }

function canhCamStickyComtent() {

	$('[data-fix]').each(function () {
		$(this).css({
			"z-index": '500'
		})
		if ($(this).attr('data-top') && $(this).attr('data-top').length) {
			$(this).css({
				"top": $(this).attr('data-top')
			})
		}
		if ($(this).attr('data-left') && $(this).attr('data-left').length) {
			$(this).css({
				"left": $(this).attr('data-left')
			})
		}
		if ($(this).attr('data-bottom') && $(this).attr('data-bottom').length) {
			$(this).css({
				"bottom": $(this).attr('data-bottom')
			})
		}
		if ($(this).attr('data-right') && $(this).attr('data-right').length) {
			$(this).css({
				"right": $(this).attr('data-right')
			})
		}

		var toFix = 0
		var typeFix = 'fixed'
		var changeFix = 'static'

		if ($(this).attr('data-fix') && $(this).attr('data-fix').length) {
			toFix = parseInt($(this).attr('data-fix'))
		}
		if ($(this).attr('data-fix-type') && $(this).attr('data-fix-type').length) {
			typeFix = $(this).attr('data-fix-type')
		}
		if ($(this).attr('data-fix-change') && $(this).attr('data-fix-change').length) {
			changeFix = $(this).attr('data-fix-change')
		}

		$(this).css({
			"position": typeFix
		})

		var scrollTop = $(window).scrollTop();
		var elementOffset = $(this).offset().top;
		var currentElementOffset = (elementOffset - scrollTop);
		if (currentElementOffset <= toFix) {
			$(this).css({
				"position": changeFix,
				"top": toFix + 'px'
			})
		}

	});
}


$(document).ready(function () {
	canhCamStickyComtent()
});

$(window).scroll(function () {
	canhCamStickyComtent()
});

$(window).resize(function () {
	canhCamStickyComtent()
})

// $(document).ready(function () {
// 	if (CANHCAM_APP.ACTIVE_VALIDATOR) {
// 		$('[data-toggle="validator"]').validator({
// 			feedback: {
// 				success: 'fa fa-check',
// 				error: 'fa fa-close'
// 			}
// 		}).on('submit', function (e) {
// 			if (e.isDefaultPrevented()) {
// 				$('[data-toggle="validator"]').find('select').parent('.form-group').addClass('has-danger')
// 			}
// 		})
// 		if ($('[data-toggle="validator"]').find('select').hasClass('has-success')) {
// 			this.removeClass('has-danger')
// 		}
// 	}
// });

// function CCHeader12() {
// 	$('.canhcam-header-12 #demoResAllInOneMenu').kResponsiveMenu({
// 		animationSpeed: 'fast', // slow, fast, 200
// 		resizeWidth: 'lg', // 'xs', 'sm', 'md', 'lg', 'xl', 480,
// 		menuType: 'horizontal', // horizontal, vertical
// 		menuPush: 'right', // right, left
// 		menuPushPosition: 'fixed', // absolute
// 		menuPushWidth: '300px', // px, %, rem
// 		menuBackDrop: true, // px, %, rem
// 	})
// };


// $(document).ready(function () {
// 	CCHeader12()
// });
// // Fixed Header
// $(window).scroll(function () {
// });

// $(window).resize(function () {
// })

$(document).ready(function(){
	openMenuHeader();
	getMapto();
})

$(window).resize(function(){
	getMapto();
})

function openMenuHeader() {
	let openBtn = $('.canhcam-header-1 .header__wrap .header__toggle--open')
	let closeBtn = $('.canhcam-header-1 .header__wrap .header__toggle--close , .canhcam-header-1 .header__wrap .header__overlay')
	let menuHeader = $('.canhcam-header-1 .header__wrap .header__menu')
	let overlayHeader = $('.canhcam-header-1 .header__wrap .header__overlay')

	$(openBtn).on('click touchstart' , function () {
		$(menuHeader).addClass('header__menu--expand');
		$(overlayHeader).addClass('header__overlay--show');
		$('.canhcam-header-1 .header__wrap .header__toggle--close').addClass('active');
	})
	$(closeBtn).on('click touchstart' , function () {
		$(menuHeader).removeClass('header__menu--expand')
		$(overlayHeader).removeClass('header__overlay--show');
		$('.canhcam-header-1 .header__wrap .header__toggle--close').removeClass('active');
	})
}

function getMapto() {
	if ($(window).width() <= 992) {
		$('[k-menu-map-to]').each(function () {
			var getTo = $(this).attr('k-menu-map-to')
			$(getTo).html($(this).clone().removeAttr('k-menu-map-to').show())
			$(this).hide()
		})
	} else {
		$('[k-menu-map-to]').each(function () {
			var getTo = $(this).attr('k-menu-map-to')
			$(getTo).html('')
			$(this).show()
		})
	}
}
function scrollNav(){
	$('.canhcam-nav-1 ul.nav').hide();
	$('.canhcam-nav-1 .trigger-btn').on('click', function() {
		if ($('.canhcam-nav-1 nav').is(':hidden') === true) {
			$('.canhcam-nav-1 nav ').slideDown('slow')
			$(this).addClass('active')
		} else {
			$('.canhcam-nav-1 nav').slideUp('slow')
			$(this).removeClass('active')
		}

	})
	$('.canhcam-nav-1 ul.nav').removeAttr( "style" )
}

function checkMenuScroll() {
	var e = $(window).scrollTop(),
		m = $('header').outerHeight(),
		n = $('.canhcam-nav-1').offset().top,
		l = $(window).height()
	if (((n - m) - e) <= 0) {
		if ($('header').hasClass("active") == true) {
			$('.canhcam-nav-1').addClass('active').css({
				"top": (m - 1) + "px"
			})
		}
	} else {
		$('.canhcam-nav-1').removeClass('active').removeAttr('style')
	}

	$('.canhcam-nav-1 nav li').each(function() {
		var u = $(this).find('a').attr('data-link')
		var s = $('#' + u).offset().top
		if (((l + e) - 400) >= s) {
			$('.canhcam-nav-1 nav li a').removeClass('active')
			$(this).find('a').addClass('active')
		}
	})
}

$(document).ready(function(){
	if($(window).width() < CANHCAM_APP.CHANGE_GRID){
		scrollNav();
	}


	$('.canhcam-nav-1 nav li a').removeClass('active')
	$('.canhcam-nav-1 nav li:first-child a').addClass('active')
	$('.canhcam-nav-1 nav li a').on('click', function() {
		$('.canhcam-nav-1 nav li a').removeClass('active')
		$(this).addClass('active')
		$('html, body').animate({
			scrollTop: $('#' + $(this).attr('data-link')).offset().top - $('.canhcam-nav-1').outerHeight() - 80
		}, 500);

		return false;
	})

	setTimeout(() => {
		if ($('header').hasClass("active") == true) {
			var m = $('header').outerHeight()
			$('.canhcam-nav-1').addClass('active').css({
				"top": (m - 1) + "px"
			})
		}
	}, 500);
});

$(window).on('scroll', function() {
	if ($('.canhcam-nav-1').length > 0) {
		checkMenuScroll()
	}
})
function scrollNav2(){
	$('.canhcam-nav-2 ul.nav').hide();
	$('.canhcam-nav-2 .trigger-btn').on('click', function() {
		if ($('.canhcam-nav-2 nav').is(':hidden') === true) {
			$('.canhcam-nav-2 nav').slideDown('slow')
			$(this).addClass('active')
		} else {
			$('.canhcam-nav-2 nav').slideUp('slow')
			$(this).removeClass('active')
		}

	})
	$('.canhcam-nav-2 ul.nav').removeAttr( "style" )
}

$(document).ready(function(){
	scrollNav2();
})
// $(function () {
// 	if ($('.canhcam-banner-1 .owl-carousel').length) {
// 		$('.canhcam-banner-1 .owl-carousel').owlCarousel({
// 			animateIn: 'slideInLeft',
// 			animateOut: 'slideOutRight',
// 			items: 1,
// 			loop: false,
// 			center: false,
// 			// padding: 10,
// 			// navText: ['<i class="lnr lnr-chevron-left"></i>', '<i class="lnr lnr-chevron-right"></i>'],
// 			// nav: true,
// 			dots: false,
// 			// autoplay: true,
// 			autoplayTimeout: 3000,
// 			autoplayHoverPause: true,
// 			callbacks: true,
// 			// margin: 30,
// 			// responsive: {
// 			// 	768: {
// 			// 		items: 3,
// 			// 	} ,
// 			// 	992: {
// 			// 		items: 4
// 			// 	}
// 			// }
// 		});
// 	}

// });

$(document).ready(function () {
	getHeightBannerHome();
});
$(window).resize(function () {
	getHeightBannerHome();
})

function getHeightBannerHome() {
	let getHeightHeader = $('header').outerHeight()
	let setHeightBannerHome = $(".canhcam-banner-1 .banners-list .swiper-container .swiper-slide");
	$(".canhcam-banner-1 .banners-list .swiper-container .swiper-slide").each((i, e) => {
		$(e).css({
			'height': 'calc(100vh - ' + getHeightHeader + 'px)'
		})
	})
}

var interleaveOffset = 0.5;

var swiperOptions = {
	loop: true,
	speed: 1000,
	grabCursor: true,
	watchSlidesProgress: true,
	mousewheelControl: true,
	keyboardControl: true,
	autoplay: {
		delay: 3000,
		disableOnInteraction: false,
	},
	// navigation: {
	// 	nextEl: ".swiper-button-next",
	// 	prevEl: ".swiper-button-prev"
	// },
	on: {
		progress: function () {
			var swiper = this;
			for (var i = 0; i < swiper.slides.length; i++) {
				var slideProgress = swiper.slides[i].progress;
				var innerOffset = swiper.width * interleaveOffset;
				var innerTranslate = slideProgress * innerOffset;
				swiper.slides[i].querySelector(".canhcam-banner-1 .slide-inner").style.transform =
					"translate3d(" + innerTranslate + "px, 0, 0)";
			}
		},
		touchStart: function () {
			var swiper = this;
			for (var i = 0; i < swiper.slides.length; i++) {
				swiper.slides[i].style.transition = "";
			}
		},
		setTransition: function (speed) {
			var swiper = this;
			for (var i = 0; i < swiper.slides.length; i++) {
				swiper.slides[i].style.transition = speed + "ms";
				swiper.slides[i].querySelector(".canhcam-banner-1 .slide-inner").style.transition =
					speed + "ms";
			}
		},
		init() {
			setTimeout(() => {
				window.dispatchEvent(new Event("resize"))
			}, 200)
		}
	}
};

var swiper = new Swiper(".canhcam-banner-1 .swiper-container", swiperOptions);

// document.querySelector('[data-toggle]').addEventListener('click', function(){
//   if (swiper.realIndex == 0) {
//     swiper.slideTo(swiper.slides.length - 1);
//   } else {
//     swiper.slideTo(0);
//   }
// });

// function logIndex () {
//   requestAnimationFrame(logIndex);
//   console.log(swiper.realIndex);
// }
// logIndex();

$(document).ready(function(){
	$('.canhcam-banner-2 .banners-list').owlCarousel({
		items: 1,
		mouseDrag: false,
		nav: false,
		dots: false
	})
})
$("body").on("click", ".canhcam-project-1 .tt__btn a", function (e) {
	e.preventDefault();

	let obj = $(this);
	let pageurl = $(this).attr('href');
	if (!pageurl.length) return;
	
	$.ajax({
		url: pageurl,
		data: {
			isajax: true
		},
		success: function success(data) {
			$('.ajaxprojectresponse').before($(data).find('.tn__wrap__item .row').html());
			$('.ajaxprojectresponse').first().remove();
			$('.btnItem').last().html($('.btnItem').first().html());
			$('.btnItem').first().remove();
			if($('.btnItem a').attr('href') == ''){
				$('.btnItem').remove()
			}
			obj.remove();
		}
	});
	return false;
});

$(function() {
	if ($('.canhcam-project-detail-1 .project_img').length) {
		$('.canhcam-project-detail-1 .project_img').owlCarousel({
			animateIn: 'slideInLeft',
			animateOut: 'slideOutRight',
			items: 1,
			loop: false,
			center: false,
			padding: 10,
			margin: 0,
			navText: ['<i class="lnr lnr-chevron-left"></i>', '<i class="lnr lnr-chevron-right"></i>'],
			nav: true,
			dots: false,
			autoplay: true,
			autoplayTimeout: 3000,
			autoplayHoverPause: true,
			callbacks: true,
		});
	}

});

$(function() {
	if ($('.canhcam-project-detail-2 .owl-carousel').length) {
		$('.canhcam-project-detail-2 .owl-carousel').owlCarousel({
			animateIn: 'slideInLeft',
			animateOut: 'slideOutRight',
			items: 1,
			loop: false,
			center: false,
			padding: 10,
			navText: ['<i class="lnr lnr-chevron-left"></i>', '<i class="lnr lnr-chevron-right"></i>'],
			nav: true,
			dots: false,
			autoplay: true,
			autoplayTimeout: 3000,
			autoplayHoverPause: true,
			callbacks: true,
			margin: 30,
			responsive: {
				768: {
					items: 3,
				} ,
				992: {
					items: 4
				}
			}
		});
	}

});

$(document).ready(function() {

	var sync1 = $("#sync1");
	var sync2 = $("#sync2");
	var slidesPerPage = 2; //globaly define number of elements per page
	var syncedSecondary = true;

	sync1.owlCarousel({
	items : 1,
	slideSpeed : 2000,
	navText: ['<i class="fas fa-angle-left"></i>', '<i class="fas fa-angle-right"></i>'],
	nav: false,
	// autoplay: true,
	dots: false,
	loop: true,
	responsiveRefreshRate : 200,
	responsive: {
		992: {
			margin: 100,
		}
	},
	}).on('changed.owl.carousel', syncPosition);

	sync2
	.on('initialized.owl.carousel', function () {
		sync2.find(".owl-item").eq(0).addClass("current");
	})
	.owlCarousel({
	items : slidesPerPage,
	dots: false,
	// autoWidth:true,
	navText: ['<i class="lnr lnr-chevron-left"></i>', '<i class="lnr lnr-chevron-right"></i>'],
	nav: true,
	smartSpeed: 200,
	slideSpeed : 500,
	responsive: {
			768: {
				items: 3
			},
			979: {
				items: 4
			},
			992: {
				
			},
			1200: {
				items: 9,
			}
		},//alternatively you can slide by 1, this way the active slide will stick to the first item in the second carousel
	responsiveRefreshRate : 100
	}).on('changed.owl.carousel', syncPosition2);

	function syncPosition(el) {
	//if you set loop to false, you have to restore this next line
	//var current = el.item.index;

	//if you disable loop you have to comment this block
	var count = el.item.count-1;
	var current = Math.round(el.item.index - (el.item.count/2) - .5);

	if(current < 0) {
		current = count;
	}
	if(current > count) {
		current = 0;
	}

	//end block

	sync2
		.find(".owl-item")
		.removeClass("current")
		.eq(current)
		.addClass("current");
	var onscreen = sync2.find('.owl-item.active').length - 1;
	var start = sync2.find('.owl-item.active').first().index();
	var end = sync2.find('.owl-item.active').last().index();

	if (current > end) {
		sync2.data('owl.carousel').to(current, 100, true);
	}
	if (current < start) {
		sync2.data('owl.carousel').to(current - onscreen, 100, true);
	}
	}

	function syncPosition2(el) {
	if(syncedSecondary) {
		var number = el.item.index;
		sync1.data('owl.carousel').to(number, 100, true);
	}
	}

	sync2.on("click", ".owl-item", function(e){
	e.preventDefault();
	var number = $(this).index();
	sync1.data('owl.carousel').to(number, 300, true);
	});
});

$(function() {
	if ($('.canhcam-about-4 .owl-carousel').length) {
		$('.canhcam-about-4 .owl-carousel').owlCarousel({
			animateIn: 'slideInLeft',
			animateOut: 'slideOutRight',
			items: 1,
			loop: false,
			center: false,
			padding: 10,
			navText: ['<i class="lnr lnr-chevron-left"></i>', '<i class="lnr lnr-chevron-right"></i>'],
			nav: true,
			dots: false,
			autoplay: true,
			autoplayTimeout: 3000,
			autoplayHoverPause: true,
			callbacks: true,
			margin: 30,
			// responsive: {
			// 	768: {
			// 		items: 3,
			// 	} ,
			// 	992: {
			// 		items: 4
			// 	}
			// }
		});
	}

});
var swiper = new Swiper('.canhcam-about-5 .swiper-container', {
	slidesPerView: 4,
	slidesPerColumn: 2,
	spaceBetween: 30,
	// pagination: {
	// 	//   el: '.swiper-pagination',
	// 	clickable: true,
	// },
	breakpoints: {
		1024: {
			slidesPerView: 4,
		},
		992: {
			navigation: false
		},
		768: {
			slidesPerView: 3,
			// navigation: {
			// 	nextEl: '.swiper-button-next',
			// 	prevEl: '.swiper-button-prev',
			// }
		},
		640: {
			slidesPerView: 2,
		},
		320: {
			slidesPerView: 1
		}
	}
});

// const container = document.querySelector('#location-container');
// const ps = new PerfectScrollbar('#location-container', {
// 	wheelSpeed: 2,
// 	wheelPropagation: true,
// 	minScrollbarLength: 20
// });
// ps.update();






$(document).ready(function(){
	createNewsSocial1();
	changeIMGtoDiv1();
})
$(window).resize(function () {
	changeIMGtoDiv1()
})

function createNewsSocial1() {
	var newsFullPath = document.URL
	var newsFullPathEncode = encodeURIComponent(document.URL)
	$('.fb-share-button').attr('data-href', newsFullPath)
	$('.fb-share-button .fb-xfbml-parse-ignore').attr('href', 'https://www.facebook.com/sharer/sharer.php?u=' + newsFullPathEncode + '&src=sdkpreparse')
	$('.twitter-share-button').attr('data-url', newsFullPath)
}

function changeIMGtoDiv1(){
	if ($(window).width() > 992) {
		$('.canhcam-new-detail-1 .othernews .item figure').each(function () {
			var tmp = $(this).find('img').attr('src')
			$(this).append('<div class="thumb"></div>')
			$(this).find('.thumb').css({
				"background-image": "url(" + tmp + ")",
				"background-position": "center center",
				"background-size": "cover"
			})
		})
	}
}
stickyFooter.init();




$(document).ready(function () {
	// $('#fullpage').fullpage({
	// 	padding: 0,
	// 	verticalCentered: true,
	// 	afterRender: () => {
	// 		// getHeightBannerHome();
	// 	}
	// });
	if ($(window).width() > 992) {
		let headerHeight = $("header").outerHeight();
		$('#fullpage').fullpage({
			paddingBottom: '0',
			scrollingSpeed: 1000,
			navigation: true,
			scrollOverflow: true,
			navigationPosition: 'right',
			anchors: ['firstPage', '2Page', '3Page', '4Page', '5Page', 'lastPage'],
			afterLoad: function (anchorLink, index) {
				countUpCanhCam();
				var loadedSection = $(this);
			},
			afterRender: function(){
				countUpCanhCam();
			},
			onLeave: function (index, nextIndex, direction) {
				
				var leavingSection = $(this);
				// after leaving section 2
				if (nextIndex.anchor !== 'firstPage') {
					$('header').slideUp();
					$("main").css('padding-top', 'initial');
				} else {
					$('header').slideDown();
					$("main").css('padding-top', headerHeight + 'px');
				}
			}
		});
	}
	$('.homepage footer').appendTo('#homeFooter')
})



$(function() {
	if ($('.canhcam-home-4 .owl-carousel').length) {
		$('.canhcam-home-4 .owl-carousel').owlCarousel({
			animateIn: 'slideInLeft',
			animateOut: 'slideOutRight',
			items: 1,
			loop: false,
			center: false,
			padding: 10,
			margin: 0,
			navText: ['<i class="mdi mdi-chevron-left"></i>', '<i class="mdi mdi-chevron-right"></i>'],
			nav: true,
			dots: false,
			autoplay: true,
			autoplayTimeout: 3000,
			autoplayHoverPause: true,
			callbacks: true,
			responsive: {
				992:{
					items: 2,
					margin: 30
				}
			}
		});
	}

});



// $(function () {
// 	$('.canhcam-map-1 .owl-carousel').owlCarousel({
// 		items: 1.2,
// 		margin: 15,
// 		dots: false,
// 		responsive: {
// 			400: {
// 				items: 1.5,
// 				margin: 29
// 			},
// 			768: {
// 				items: 2
// 			},
// 			992: {
// 				items: 3,
// 				nav: true,
// 				navText: ["<i class='lnr lnr-chevron-left'></i>","<i class='lnr lnr-chevron-right'></i>"]
// 			}
// 		}
// 	})
// });